"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var InputTrimDirective = (function (_super) {
    __extends(InputTrimDirective, _super);
    function InputTrimDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(InputTrimDirective.prototype, "value", {
        set: function (val) {
            this.writeValue(val);
            this.onChange(val);
        },
        enumerable: true,
        configurable: true
    });
    InputTrimDirective.prototype.onBlur = function (event, value) {
        this.updateValue(event, value);
    };
    InputTrimDirective.prototype.onInput = function (event, value) {
        this.updateValue(event, value);
    };
    InputTrimDirective.prototype.updateValue = function (event, value) {
        this.value = (this.trim !== '' && event !== this.trim) ? value : value.trim();
    };
    InputTrimDirective.decorators = [
        { type: core_1.Directive, args: [{
                    selector: 'input[trim], textarea[trim]',
                    providers: [
                        { provide: forms_1.NG_VALUE_ACCESSOR, useExisting: InputTrimDirective, multi: true }
                    ],
                },] },
    ];
    InputTrimDirective.ctorParameters = function () { return []; };
    InputTrimDirective.propDecorators = {
        'trim': [{ type: core_1.Input },],
        'onBlur': [{ type: core_1.HostListener, args: ['blur', ['$event.type', '$event.target.value'],] },],
        'onInput': [{ type: core_1.HostListener, args: ['input', ['$event.type', '$event.target.value'],] },],
    };
    return InputTrimDirective;
}(forms_1.DefaultValueAccessor));
exports.InputTrimDirective = InputTrimDirective;



//////////////////
// WEBPACK FOOTER
// C:/Users/EZepeda/Desktop/Explora/adminexplora/~/ng2-trim-directive/dist/input-trim.directive.js
// module id = ../../../../ng2-trim-directive/dist/input-trim.directive.js
// module chunks = 4